import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { generateDocxFailed, generateDocxSuccessful } from '../actions';

export default function* generateDocx(action) {
  try {
    const url = `${BACKEND_URL}/resources/documents/${action.payload}/generate-docx`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST');
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(generateDocxSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(generateDocxFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(generateDocxFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
